import React from 'react';
import { FormikHelpers } from 'formik';
import { Trans, useTranslation } from 'react-i18next';

import { useExtendedFormikContext } from '@uncinc/uncinc-react-kitchen-sink/dist/components/Form/FormikWrapper';

import usePopup from '../../../../hooks/usePopup';
import Button from '../../../Button';
import Popup from '../../../Popup';
import { BuddiesFormValues } from '../types';

interface FormikProps extends FormikHelpers<BuddiesFormValues> {
  values: BuddiesFormValues;
}

interface BuddiesFormConfirmationProps extends ReturnType<typeof usePopup<HTMLDivElement>> {
  onSubmit: (values: BuddiesFormValues, helpers: FormikHelpers<BuddiesFormValues>) => void;
}

const BuddiesFormConfirmation: React.FC<BuddiesFormConfirmationProps> = (props) => {
  const { onSubmit, ...popup } = props;

  const { t } = useTranslation();
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const { values, ...helpers }: FormikProps = useExtendedFormikContext();

  return (
    <Popup
      {...popup.popupProps}
      title={t('form.buddy_form.confirmation.title')}
      closeButtonText={t('buttons.cancel')}
      cta={(
        <Button
          onClick={() => {
            popup.close();
            helpers.resetForm();
            onSubmit(values, helpers);
          }}
        >
          {t('form.buddy_form.confirmation.confirm')}
        </Button>
      )}
    >
      {[
        ...t('form.buddy_form.confirmation.body', {
          name: values.name,
          email: values.email,
          returnObjects: true,
        }),
      ].map((content, idx) => (
        <Trans>
          {/* eslint-disable-next-line react/no-array-index-key */}
          <p key={`confirmation-body-content-${idx}`}>
            {content}
          </p>
        </Trans>
      ))}
    </Popup>
  );
};

export default BuddiesFormConfirmation;
